import { HirerTeamMemberSendEmailForm } from '@seek/hirer-team-member-job-access';
import { useTranslations } from '@vocab/react';
import { Stack, Heading, Strong, Text, Box } from 'braid-design-system';
import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import type AppState from 'src/types/appState';

import translations from './.vocab';

export const StepTeamEmailPanel = (): JSX.Element => {
  const { jobTitle, job, firstName } = useSelector(
    (state: AppState) => ({
      jobTitle: state.formData.jobTitle,
      job: state.session.job,
      firstName: state.session.userFirstName,
    }),
    shallowEqual,
  );
  const { t } = useTranslations(translations);
  return (
    <Box paddingTop="xsmall">
      <Stack space="large">
        <Stack space="small">
          <Heading level="3">
            <Strong>{t('step-team-email-panel-heading')}</Strong>
          </Heading>
          <Text tone="secondary">{t('step-team-email-panel-description')}</Text>
        </Stack>
        <Box paddingY="large" paddingX="xxsmall">
          <HirerTeamMemberSendEmailForm
            id="team-members-email"
            senderFirstName={firstName}
            senderLastName=""
            jobId={job?.id ?? '0'}
            jobTitle={jobTitle}
          />
        </Box>
      </Stack>
    </Box>
  );
};
